import { ModalBody, UtilityModal } from '../components'

// AppSumo billing-channel helpers (who the user is, where they upgrade).
// Generic plan-limit helpers (contact cap, broadcast window) live in
// planLimits.jsx.

const DEFAULT_CHANGE_PLAN_URL = 'https://appsumo.com/account/products/'

export const isAppsumoUser = (entitlements = window?.entitlements) => {
  return !!(entitlements?.appsumoUser || entitlements?.appsumo_user || entitlements?.contactSupportForUpgrade || entitlements?.contact_support_for_upgrade)
}

export const getAppsumoChangePlanUrl = (entitlements = window?.entitlements) => {
  return entitlements?.appsumoChangePlanUrl || entitlements?.appsumo_change_plan_url || DEFAULT_CHANGE_PLAN_URL
}

/**
 * Show AppSumo-specific billing modal instead of Braintree pricing / cancel flows.
 * @param {'upgrade'|'cancel'} intent
 */
export const showAppsumoBillingModal = (intent = 'upgrade', entitlements = window?.entitlements) => {
  const changePlanUrl = getAppsumoChangePlanUrl(entitlements)
  const isCancel = intent === 'cancel'

  const title = isCancel ? 'Manage your AppSumo plan' : 'Upgrade via AppSumo'
  const description = isCancel
    ? 'Your plan is managed through AppSumo. To cancel or change your lifetime deal, please use your AppSumo account, or contact MailMunch support for help.'
    : 'You\'re on an AppSumo lifetime plan. To upgrade or change tiers, please use AppSumo, or contact MailMunch support.'

  UtilityModal({
    id: 'appsumo-billing-modal',
    body: (props) => (
      <ModalBody
        {...props}
        title={title}
        description={description}
        action="primary"
        cancelButton={false}
        buttons={[
          {
            label: isCancel ? 'Open AppSumo' : 'Upgrade on AppSumo',
            action: 'primary',
            className: "ml-2",
            onClick: () => {
              window.open(changePlanUrl, '_blank', 'noopener,noreferrer')
              props.handleClose?.()
            },
          },
          {
            label: 'Contact Support',
            action: 'default',
            onClick: () => {
              window?.Intercom('show')
              props.handleClose?.()
            },
          },
        ]}
      />
    ),
  })
}

/**
 * Wrap window.pricing.show so AppSumo users get the support modal instead of the pricing chart.
 */
export const installAppsumoPricingOverride = (entitlements = window?.entitlements) => {
  if (!isAppsumoUser(entitlements)) return

  const previousShow = typeof window.pricing?.show === 'function' ? window.pricing.show.bind(window.pricing) : null

  window.pricing = window.pricing || {}
  window.pricing.__appsumoOriginalShow = previousShow
  window.pricing.show = function () {
    showAppsumoBillingModal('upgrade', entitlements)
  }
}
